import { ProductType } from '@inter-ikea-storageone/range';
export const lightsInSceneNeedControler = (coreApi) => {
    const innerLights = coreApi.entities.getByProductType(ProductType.PLATSA_INNER_LIGHT);
    return innerLights.some(light => coreApi.entities.getCoveringFronts(light).length === 0);
};
//# sourceMappingURL=lights.js.map